/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore explicitly imported 'react' to avoid commonjs build issues with compiled library. Ref: https://atlassian.slack.com/archives/C08BQ9QDRFX/p1748283909199679
// eslint-disable-next-line no-unused-vars
import React, { lazy } from 'react';

import { jsx } from '@atlaskit/css';
import type { NewCoreIconProps } from '@atlaskit/icon';

// Medium icons
const ArchiveIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-archive-icon-medium" */ '@atlaskit/icon-file-type/glyph/archive/24'
		),
);
const AudioIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-audio-icon-medium" */ '@atlaskit/icon-file-type/glyph/audio/24'
		),
);
const DocumentIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-document-icon-medium" */ '@atlaskit/icon-file-type/glyph/document/24'
		),
);
const ExcelIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-excel-spreadsheet-icon-medium" */ '@atlaskit/icon-file-type/glyph/excel-spreadsheet/24'
		),
);
const GenericIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-generic-icon-medium" */ '@atlaskit/icon-file-type/glyph/generic/24'
		),
);
const GoogleDocIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-google-doc-icon-medium" */ '@atlaskit/icon-file-type/glyph/google-doc/24'
		),
);
const GoogleSheetIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-google-sheet-icon-medium" */ '@atlaskit/icon-file-type/glyph/google-sheet/24'
		),
);
const GoogleSlideIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-google-slide-icon-medium" */ '@atlaskit/icon-file-type/glyph/google-slide/24'
		),
);
const ImageIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-image-icon-medium" */ '@atlaskit/icon-file-type/glyph/image/24'
		),
);
const PDFIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-pdf-doc-icon-medium" */ '@atlaskit/icon-file-type/glyph/pdf-document/24'
		),
);
const PowerpointIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-powerpoint-icon-medium" */ '@atlaskit/icon-file-type/glyph/powerpoint-presentation/24'
		),
);
const SourceCodeIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-source-code-icon-medium" */ '@atlaskit/icon-file-type/glyph/source-code/24'
		),
);
const SpreadsheetIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-spreadsheet-icon-medium" */ '@atlaskit/icon-file-type/glyph/spreadsheet/24'
		),
);
const VideoIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-video-icon-medium" */ '@atlaskit/icon-file-type/glyph/video/24'
		),
);
const WordDocumentIconMedium = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-word-doc-icon-medium" */ '@atlaskit/icon-file-type/glyph/word-document/24'
		),
);

// Icons
const ArchiveIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-archive-icon" */ '@atlaskit/icon-file-type/glyph/archive/16'
		),
);
const AudioIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-audio-icon" */ '@atlaskit/icon-file-type/glyph/audio/16'
		),
);
const DocumentIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-document-icon" */ '@atlaskit/icon-file-type/glyph/document/16'
		),
);
const ExcelIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-excel-spreadsheet-icon" */ '@atlaskit/icon-file-type/glyph/excel-spreadsheet/16'
		),
);
const GenericIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-generic-icon" */ '@atlaskit/icon-file-type/glyph/generic/16'
		),
);
const GoogleDocIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-google-doc-icon" */ '@atlaskit/icon-file-type/glyph/google-doc/16'
		),
);
const GoogleSheetIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-google-sheet-icon" */ '@atlaskit/icon-file-type/glyph/google-sheet/16'
		),
);
const GoogleSlideIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-google-slide-icon" */ '@atlaskit/icon-file-type/glyph/google-slide/16'
		),
);
const ImageIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-image-icon" */ '@atlaskit/icon-file-type/glyph/image/16'
		),
);
const PDFIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-pdf-doc-icon" */ '@atlaskit/icon-file-type/glyph/pdf-document/16'
		),
);
const PowerpointIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-powerpoint-icon" */ '@atlaskit/icon-file-type/glyph/powerpoint-presentation/16'
		),
);
const SourceCodeIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-source-code-icon" */ '@atlaskit/icon-file-type/glyph/source-code/16'
		),
);
const SpreadsheetIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-spreadsheet-icon" */ '@atlaskit/icon-file-type/glyph/spreadsheet/16'
		),
);
const VideoIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-video-icon" */ '@atlaskit/icon-file-type/glyph/video/16'
		),
);
const WordDocumentIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-word-doc-icon" */ '@atlaskit/icon-file-type/glyph/word-document/16'
		),
);

// New icons
const ImageIconNew = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-image-icon" */ '@atlaskit/icon/core/image'
		),
);

const FileNew = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-pdf-icon" */ '@atlaskit/icon/core/file'
		),
);

const VideoIconNew = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-video-icon" */ '@atlaskit/icon/core/video'
		),
);

const AudioIconNew = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-audio-icon" */ '@atlaskit/icon/core/audio'
		),
);

const SpreadsheetIconNew = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-message-spreadsheet-icon" */ '@atlaskit/icon/core/spreadsheet'
		),
);

type FileIconProps = {
	fileName: string;
	size?: 'small' | 'medium';
};

export const FileIconSimple = ({
	fileName,
	...props
}: FileIconProps & Omit<NewCoreIconProps, 'label'>): JSX.Element => {
	const fileExtension = fileName.split('.').pop();

	if (!fileExtension) {
		return <GenericIcon label="" />;
	}

	switch (fileExtension.toLowerCase()) {
		// Images
		case 'jpg':
		case 'jpeg':
		case 'png':
		case 'gif':
			return <ImageIconNew {...props} label="" />;
		// Spreadsheets
		case 'csv':
		case 'tsv':
		case 'xls':
		case 'xlsx':
			return <SpreadsheetIconNew {...props} label="" />;
		// Audio
		case 'mp3':
		case 'wav':
		case 'flac':
		case 'ogg':
			return <AudioIconNew {...props} label="" />;
		// Videos
		case 'mp4':
		case 'avi':
		case 'mov':
		case 'mkv':
			return <VideoIconNew {...props} label="" />;

		default:
			return <FileNew {...props} label="" />;
	}
};

export const FileIcon = ({ fileName, size = 'small' }: FileIconProps): JSX.Element => {
	const fileExtension = fileName.split('.').pop();

	if (!fileExtension) {
		return size === 'small' ? <GenericIcon label="" /> : <GenericIconMedium label="" />;
	}

	switch (fileExtension.toLowerCase()) {
		// TXT Files
		case 'txt':
		case 'md':
		case 'log':
		case 'json':
		case 'yaml':
		case 'yml':
		case 'xml':
		case 'rtf':
			return size === 'small' ? <DocumentIcon label="" /> : <DocumentIconMedium label="" />;

		// Plain Spreadsheets
		case 'csv':
		case 'tsv':
			return size === 'small' ? <SpreadsheetIcon label="" /> : <SpreadsheetIconMedium label="" />;

		// Word Documents
		case 'doc':
		case 'docx':
			return size === 'small' ? <WordDocumentIcon label="" /> : <WordDocumentIconMedium label="" />;

		// PDF Files
		case 'pdf':
			return size === 'small' ? <PDFIcon label="" /> : <PDFIconMedium label="" />;

		// PowerPoint Presentations
		case 'ppt':
		case 'pptx':
			return size === 'small' ? <PowerpointIcon label="" /> : <PowerpointIconMedium label="" />;

		// Excel Spreadsheets
		case 'xls':
		case 'xlsx':
			return size === 'small' ? <ExcelIcon label="" /> : <ExcelIconMedium label="" />;

		// Images
		case 'jpg':
		case 'jpeg':
		case 'png':
		case 'gif':
			return size === 'small' ? <ImageIcon label="" /> : <ImageIconMedium label="" />;

		// Audio
		case 'mp3':
		case 'wav':
		case 'flac':
		case 'ogg':
			return size === 'small' ? <AudioIcon label="" /> : <AudioIconMedium label="" />;

		// Videos
		case 'mp4':
		case 'avi':
		case 'mov':
		case 'mkv':
			return size === 'small' ? <VideoIcon label="" /> : <VideoIconMedium label="" />;
		case 'zip':
		case 'rar':
		case '7z':
			return size === 'small' ? <ArchiveIcon label="" /> : <ArchiveIconMedium label="" />;

		// Source Code
		case 'css':
		case 'html':
		case 'htm':
		case 'c':
		case 'cpp':
		case 'cs':
		case 'java':
		case 'js':
		case 'jsx':
		case 'vue':
		case 'svelte':
		case 'as':
		case 'sh':
		case 'bash':
		case 'bats':
		case 'h':
		case 'cc':
		case 'cxx':
		case 'hpp':
		case 'hxx':
		case 'coffee':
		case 'litcoffee':
		case 'clj':
		case 'cljs':
		case 'cljc':
		case 'edn':
		case 'dockerfile':
		case 'dockerignore':
		case 'erl':
		case 'hrl':
		case 'f':
		case 'for':
		case 'f90':
		case 'f95':
		case 'f03':
		case 'f08':
		case 'go':
		case 'kt':
		case 'kts':
		case 'tex':
		case 'sty':
		case 'cls':
		case 'less':
		case 'makefile':
		case 'mak':
		case 'mk':
		case 'm':
		case 'mat':
		case 'mm':
		case 'pas':
		case 'pp':
		case 'p':
		case 'pl':
		case 'pm':
		case 't':
		case 'pod':
		case 'php':
		case 'php3':
		case 'php4':
		case 'php5':
		case 'phtml':
		case 'py':
		case 'pyw':
		case 'pyc':
		case 'pyo':
		case 'pyd':
		case 'r':
		case 'rb':
		case 'erb':
		case 'rake':
		case 'gemspec':
		case 'rs':
		case 'rslib':
		case 'sas':
		case 'sas7bdat':
		case 'scss':
		case 'sass':
		case 'scala':
		case 'sc':
		case 'sbt':
		case 'st':
		case 'sm':
		case 'sql':
		case 'swift':
		case 'tcl':
		case 'itcl':
		case 'ts':
		case 'tsx':
		case 'v':
		case 'vh':
		case 'vhd':
		case 'vhdl':
			return size === 'small' ? <SourceCodeIcon label="" /> : <SourceCodeIconMedium label="" />;
		case 'gdoc':
			return size === 'small' ? <GoogleDocIcon label="" /> : <GoogleDocIconMedium label="" />;
		case 'gsheet':
			return size === 'small' ? <GoogleSheetIcon label="" /> : <GoogleSheetIconMedium label="" />;
		case 'gslide':
			return size === 'small' ? <GoogleSlideIcon label="" /> : <GoogleSlideIconMedium label="" />;
		default:
			return size === 'small' ? <GenericIcon label="" /> : <GenericIconMedium label="" />;
	}
};
